<template>
  <div class="panel">
    <loader watch="licenceArea">
      <b-row class="mb-4">
        <b-col>
          <h2 class="mq">Zones</h2>
        </b-col>
        <b-col class="text-right">
          <b-button :to="{ name: 'newZone' }" variant="rounded">
            Add zone
            <Icon name="add" />
          </b-button>
        </b-col>
      </b-row>
      <div class="striped-list">
        <div v-for="zone in zones" :key="zone.id" class="striped-list__row">
          <b-row class="align-items-center">
            <b-col>
              <template v-if="zone.name"> {{ zone.name }} ({{ zone.code }}) </template>
              <template v-else>
                {{ zone.code }}
              </template>
            </b-col>
            <b-col class="text-right striped-list__actions">
              <b-button variant="link" class="btn-icon-only" @click="edit(zone)">
                <Icon name="edit" />
              </b-button>
              <b-button
                variant="link"
                class="btn-icon-only ml-2"
                @click="$refs[`modal-${zone.code}`][0].show()"
              >
                <Icon name="delete" />
              </b-button>
              <b-modal
                :ref="`modal-${zone.code}`"
                ok-title="Delete"
                cancel-title="Cancel"
                ok-variant="rounded btn-delete"
                cancel-variant="link"
                class="text-left"
                @ok="remove(zone.code)"
              >
                <p class="lead">Are you sure you want to delete this zone?</p>
                You won't be able to undo your action.
              </b-modal>
            </b-col>
          </b-row>
        </div>
      </div>
    </loader>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ZonesList',
  props: ['projectCode', 'reload'],
  data() {
    return {
      mainError: null,
      inputsErrors: []
    };
  },
  computed: {
    ...mapState('zones', ['zones'])
  },
  created() {
    if (this.reload) {
      this.fetch(true);
    }
  },
  mounted() {
    this.fetch();
  },
  methods: {
    fetch(reload) {
      this.$store.dispatch('zones/fetchAll', {
        projectCode: this.projectCode,
        reloadProjectLicenceAreas: reload
      });
    },
    remove(zoneCode) {
      const res = this.$store.dispatch('zones/remove', {
        projectCode: this.projectCode,
        zoneCode
      });

      res.then(() => this.fetch(true));
    },
    edit(zone) {
      this.$router.push({
        name: 'editZone',
        params: {
          projectCode: this.projectCode,
          zoneCode: zone.code,
          zoneData: zone
        }
      });
    }
  }
};
</script>
